export const APP_LOGO_URL = {
  link: process.env.PUBLIC_URL + '/img/logo.ico',
  width: '30px',
  height: '30px',
};

